export default __webpack_public_path__ + "static/media/anastasia-kristensen.21f8d291.jpg";